<div class="progress">
  <h1>Hämtar dokument för underskrift</h1>
  <div class="dot-pulse"></div>
</div>
